import { IAppAction } from "store/appAction";

export const searchActions = {
  GET_TRENDING_SEARCHES: "GET_TRENDING_SEARCHES",
  SET_TRENDING_SEARCHES_SUCCESS: "GET_TRENDING_SEARCHES_SUCCESS",
  SET_TRENDING_SEARCHES_ERROR: "GET_TRENDING_SEARCHES_ERROR",

  GET_CREATORS_SEARCHES: "GET_CREATORS_SEARCHES",
  SET_CREATORS_SEARCHES_SUCCESS: "GET_CREATORS_SEARCHES_SUCCESS",
  SET_CREATORS_SEARCHES_ERROR: "GET_CREATORS_SEARCHES_ERROR",

  GET_NICHES_SEARCHES: "GET_NICHES_SEARCHES",
  SET_NICHES_SEARCHES_SUCCESS: "SET_NICHES_SEARCHES_SUCCESS",
  SET_NICHES_SEARCHES_ERROR: "SET_NICHES_SEARCHES_ERROR",

  GET_TAGS_SEARCHES: "GET_TAGS_SEARCHES",
  SET_TAGS_SEARCHES_SUCCESS: "SET_TAGS_SEARCHES_SUCCESS",
  SET_TAGS_SEARCHES_ERROR: "SET_TAGS_SEARCHES_ERROR",

  GET_HISTORY_SEARCHES: "GET_HISTORY_SEARCHES",
  SET_HISTORY_SEARCHES_SUCCESS: "SET_HISTORY_SEARCHES_SUCCESS",
  SET_HISTORY_SEARCHES_ERROR: "SET_HISTORY_SEARCHES_ERROR"
};

export const getTrendingSearches = (): IAppAction => ({ type: searchActions.GET_TRENDING_SEARCHES });
export const setTrendingSearchesSuccess = (payload: any): IAppAction => ({
  type: searchActions.SET_TRENDING_SEARCHES_SUCCESS,
  payload
});
export const setTrendingSearchesError = (error: Error): IAppAction => ({
  type: searchActions.SET_TRENDING_SEARCHES_ERROR,
  payload: error
});

export const getCreatorsSearches = (payload: string): IAppAction => ({ type: searchActions.GET_CREATORS_SEARCHES, payload });
export const setCreatorsSearchesSuccess = (payload: any): IAppAction => ({
  type: searchActions.SET_CREATORS_SEARCHES_SUCCESS,
  payload
});
export const setCreatorsSearchesError = (error: Error): IAppAction => ({
  type: searchActions.SET_CREATORS_SEARCHES_ERROR,
  payload: error
});

export const getNichesSearches = (payload: string): IAppAction => ({ type: searchActions.GET_NICHES_SEARCHES, payload });
export const setNichesSearchesSuccess = (payload: any): IAppAction => ({
  type: searchActions.SET_NICHES_SEARCHES_SUCCESS,
  payload
});
export const setNichesSearchesError = (error: Error): IAppAction => ({
  type: searchActions.SET_NICHES_SEARCHES_ERROR,
  payload: error
});

export const getTagsSearches = (payload: string): IAppAction => ({ type: searchActions.GET_TAGS_SEARCHES, payload });
export const setTagsSearchesSuccess = (payload: any): IAppAction => ({
  type: searchActions.SET_TAGS_SEARCHES_SUCCESS,
  payload
});
export const setTagsSearchesError = (error: Error): IAppAction => ({
  type: searchActions.SET_TAGS_SEARCHES_ERROR,
  payload: error
});

export const getHistorySearches = (payload: string): IAppAction => ({ type: searchActions.GET_HISTORY_SEARCHES, payload });
export const setHistorySearchesSuccess = (payload: any): IAppAction => ({
  type: searchActions.SET_HISTORY_SEARCHES_SUCCESS,
  payload
});
export const setHistorySearchesError = (error: Error): IAppAction => ({
  type: searchActions.SET_HISTORY_SEARCHES_ERROR,
  payload: error
});
